import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useCreateLoan } from "@/api/financial";
import { PageHeader } from "@/components/PageHeader";
import { LoanForm } from "./-components/LoanForm";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/financial/loans/new",
)({
	component: NewLoanPage,
});

function NewLoanPage() {
	const { orgId } = Route.useParams();
	const { t } = useTranslation();
	const navigate = Route.useNavigate();

	const createMutation = useCreateLoan();

	const goToList = () =>
		navigate({ to: "/app/org/$orgId/financial/loans", params: { orgId } });

	return (
		<div className="mx-auto flex w-full max-w-2xl flex-col gap-6">
			<PageHeader title={t("financial.loans.form.newTitle")} showBackButton />
			<div className="card bg-base-100 shadow-md">
				<div className="card-body">
					<LoanForm
						orgId={orgId}
						enableDraft
						isSubmitting={createMutation.isPending}
						onSubmit={(data, clearDraft) =>
							createMutation
								.mutateAsync({ organizationId: orgId, data })
								.then((loan) => {
									clearDraft();
									return navigate({
										to: "/app/org/$orgId/financial/loans/$loanId",
										params: { orgId, loanId: loan.id },
									});
								})
						}
						onCancel={goToList}
					/>
				</div>
			</div>
		</div>
	);
}
